import { z } from 'zod';

// Internal helper to match Zod type name (needed for union/discriminated union detection)
const isTypeName = (input: z.ZodTypeAny, kind: z.ZodFirstPartyTypeKind) =>
  (input as any)._def?.typeName === kind;

const extractKeysFromUnion = (input: z.ZodTypeAny): string[] | null => {
  const options: z.ZodTypeAny[] = (input as any)._def.options;
  const all = new Set<string>();
  for (const opt of options) {
    const keys = collectObjectKeys(opt);
    if (!keys) {
      return null;
    }
    for (const k of keys) {
      all.add(k);
    }
  }
  return [...all];
};

const extractKeysFromDiscriminatedUnion = (
  input: z.ZodTypeAny,
): string[] | null => {
  const options: z.ZodTypeAny[] = [...(input as any).options];
  const all = new Set<string>();
  for (const opt of options) {
    const keys = collectObjectKeys(opt);
    if (!keys) {
      return null;
    }
    for (const k of keys) {
      all.add(k);
    }
  }
  return [...all];
};

// Allow ZodObject, ZodEffects wrapping a ZodObject, ZodUnion / ZodDiscriminatedUnion of such objects.
export const collectObjectKeys = (input: z.ZodTypeAny): string[] | null => {
  if (input instanceof z.ZodObject) {
    return Object.keys(input.shape);
  }
  if (input instanceof z.ZodEffects) {
    return collectObjectKeys((input as any)._def?.schema);
  }
  if (isTypeName(input, z.ZodFirstPartyTypeKind.ZodUnion)) {
    return extractKeysFromUnion(input);
  }
  if (isTypeName(input, z.ZodFirstPartyTypeKind.ZodDiscriminatedUnion)) {
    return extractKeysFromDiscriminatedUnion(input);
  }
  return null;
};
